<template>
    <div>
        <div class="title">
            <i class="material-icons success">check_circle</i>
            <span>紀錄已送出邀請</span>
        </div>
        
        <div class="dialog-second-content">
            <p></p>
        </div>

        <a href="/coursework" @click="confirm">我知道了</a>
    </div>
</template>
<script>
export default {
    name:"modalTest",
    props:{
        params:{
        }
    },
    data(){
        return{
            info:this.params.firstInput,            
        }
    },
    created(){
    },
    methods:{
        confirm(){
            this.$emit("close",this.info);            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling-apply/PopModalTest.vue